// extracted by mini-css-extract-plugin
export default {"wrap":"FF-z","subtitle":"GF-z","contentWrap":"HF-z","imgWrap":"IF-z","heading":"JF-z","copy":"KF-z"};